const FETCH_DASHBOARD_MODELS_START = 'dashboardLite/FETCH_DASHBOARD_MODELS_START';
const FETCH_DASHBOARD_MODELS_SUCCESS = 'dashboardLite/FETCH_DASHBOARD_MODELS_SUCCESS';
const FETCH_DASHBOARD_MODELS_FAIL = 'dashboardLite/FETCH_DASHBOARD_MODELS_FAIL';

export const DASHBOARD_LITE_MODELS_ACTION_TYPES = {
    FETCH_DASHBOARD_MODELS_START,
    FETCH_DASHBOARD_MODELS_SUCCESS,
    FETCH_DASHBOARD_MODELS_FAIL
};

const FETCH_PARTNER_BROKER_START = 'dashboardLite/FETCH_PARTNER_BROKER_START';
const FETCH_PARTNER_BROKER_SUCCESS = 'dashboardLite/FETCH_PARTNER_BROKER_SUCCESS';
const FETCH_PARTNER_BROKER_FAIL = 'dashboardLite/FETCH_PARTNER_BROKER_FAIL';

export const DASHBOARD_LITE_PARTNER_BROKER_ACTION_TYPES = {
    FETCH_PARTNER_BROKER_START,
    FETCH_PARTNER_BROKER_SUCCESS,
    FETCH_PARTNER_BROKER_FAIL
};

export const dashboardLiteSagaActionTypes = {
    ...DASHBOARD_LITE_MODELS_ACTION_TYPES,
    ...DASHBOARD_LITE_PARTNER_BROKER_ACTION_TYPES
};
